import { Injectable } from '@angular/core';
import { getCorporatePartner } from '@com-delta-idp/mnx-capability-profile-selector-smart';
import { ICorporatePartner } from '@com-delta-idp/mnx-sitewide-footer-ui';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { FooterHelperAdapterService } from './footer-helper.adapter.service';

@Injectable({
  providedIn: 'root'
})
export class FooterExtendedAdapterService extends FooterHelperAdapterService {
  corpPartner: ICorporatePartner = {} as ICorporatePartner;
  pageName = ''; //TODO: add the page name as per the existing global footer
  partnerId = 'default';
  hasCorpCookie: string | null = '';

  setBusinessFlagForHipmunk(): void {
    this.corpPartner = getCorporatePartner('hipmunk');
    this.switchingAccountService.toggleAccount(false, true);
  }

  setCookie(): boolean | string | null {
    return this.cookieHelper.getCookieValue('isHipmunk') !== null
      ? this.cookieHelper.getCookieValue('isHipmunk')
      : false;
  }

  setPartnerIdName(partnerIdName: string): string {
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    if (setPartnerToPersonal && setPartnerToPersonal.length) {
      return setPartnerToPersonal;
    } else {
      return partnerIdName;
    }
  }

  setPageRestrictedPartnerId(pageRestricted: boolean): void {
    this.partnerId = pageRestricted
      ? 'hipmunk'
      : this.setPartnerIdName('default');
  }

  setHipmunkCookieExtended(hipmunkPaxCount: string | number): void {
    if (hipmunkPaxCount === '1' || hipmunkPaxCount === 1) {
      this.cookieHelper.setCookieName('isHipmunk', true, 0, true);
      this.setBusinessFlagForHipmunk();
      this.partnerId = 'hipmunk';
    } else {
      this.cookieHelper.setCookieName('isHipmunk', '', 0, false);
      this.partnerId = this.setPartnerIdName('default');
    }
  }

  setHipmunkCookieHelper(): void {
    const hipmunkPaxCount = this.urlUtil.getUrlParameter('paxCount');
    if (
      this.urlUtil.getUrlParameter('hipmunk-id') !== null &&
      hipmunkPaxCount !== null
    ) {
      this.setHipmunkCookieExtended(hipmunkPaxCount);
    }
  }

  getPartnerIdWithHasCorpCookie(): void {
    if (this.hasCorpCookie) {
      this.partnerId = 'edp';
    }
  }

  setHipmunkCookieForFooter(pageRestricted: boolean): void {
    const hipmunkCookie = this.setCookie();
    if (this.pageName !== '' && this.pageName === 'confirmation') {
      this.cookieHelper.setCookieName('isHipmunk', '', 0, false);
      this.partnerId = this.setPartnerIdName('default');
    } else if (hipmunkCookie) {
      this.setBusinessFlagForHipmunk();
      this.setPageRestrictedPartnerId(pageRestricted);
    } else {
      this.setHipmunkCookieHelper();
    }
    this.hasCorpCookie = this.cookieHelper.getCookies('corp');
    this.getPartnerIdWithHasCorpCookie();
    this.corpPartner = getCorporatePartner(this.partnerId);
  }

  getisDarkSiteEnabled(headerFooterData: HeaderFooterMachCore): boolean {
    return headerFooterData?.darkSite?.isEnabled === 'true';
  }
}
